import { render, staticRenderFns } from "./DeliveryToday.vue?vue&type=template&id=2c7e651f&"
import script from "./DeliveryToday.vue?vue&type=script&lang=js&"
export * from "./DeliveryToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports